import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from "react-router-dom";
import profileImg from '../../assets/globalImgs/profile.png'
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import moment from 'moment';
import Select from 'react-select';


export default function Assethandover() {
    const navigate = useNavigate();
    const [employeeData, setEmployeeData] = useState({});
    const [loading, setLoading] = useState(false);
    const [assets, setAssets] = useState([]);
    const [handoverAll, setHandoverAll] = useState(false);
    const [handoverStatus, setHandoverStatus] = useState({});
    const [employees, setEmployees] = useState([]);
    const [formData, setFormData] = useState({
        AssetHandoveredTo: '',
        AssetHandoveredDate: '',
        comments: ''
    });
    const handleErrors = useHandleErrors();
    const empId = localStorage.getItem("empId")
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);

    const fetchEmployeeData = async () => {
        if (empId) {
            setLoading(true);
            try {
                const path = `/getOnboardEmployeeDetails?EmployeeId=${empId}`;
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setEmployeeData(response.data);
                setAssets(response.data?.getAssetListDetails);
                const initialStatus = assets.reduce((acc, asset) => {
                    acc[asset.assetId] = false;
                    return acc;
                }, {});
                setHandoverStatus(initialStatus);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchEmployeeData();
            fetchEmployeeReport()
            hasFetchedRef.current = true;
        }
    }, [empId]);

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const fetchEmployeeReport = async () => {
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;

            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                console.log("response", response);
                const activeEmployees = response.data.onboardEmployeeDetails?.filter(employee => employee.Status === 'Active');
                setEmployees(activeEmployees);
            }
            else {
                handleErrors(response)
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    const handleCheckboxChange = (assetId) => {
        setHandoverStatus((prevStatus) => {
            const newStatus = { ...prevStatus, [assetId]: !prevStatus[assetId] };

            // If there is only one asset and its status is true, set handoverAll to true
            if (assets.length === 1 && Object.values(newStatus)[0] === true) {
                setHandoverAll(true);
            } else {
                setHandoverAll(false);
            }

            return newStatus;
        });
    };

    const handleHandoverAllChange = () => {
        const newHandoverAll = !handoverAll;
        setHandoverAll(newHandoverAll);
        const newStatus = assets.reduce((acc, asset) => {
            acc[asset.AssetId] = newHandoverAll;
            return acc;
        }, {});
        setHandoverStatus(newStatus);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const allChecked = Object.values(handoverStatus).every(status => status);
    const anyChecked = Object.values(handoverStatus).some(status => status);

    const handleNext = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (assets.length > 0) {
            if (!formData.handedOverTo) {
                toast.error("Asset Handover To is Required", {
                    position: toast.POSITION.TOP_CENTER,
                });
                return setLoading(false);;
            }
            if (!formData.handedOverDate) {
                toast.error("Asset Handover Date is Required", {
                    position: toast.POSITION.TOP_CENTER,
                });
                return setLoading(false);;
            }
        }
        else {
            toast.error("No Assests Avaialable", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        try {
            const path = "/assignAsset";
            const URL = process.env.REACT_APP_BE_URL + path;
            const selectedAssets = assets.filter(asset => handoverStatus[asset.AssetId]).map(asset => ({
                AssetId: asset.AssetId,
                CategoryType: asset.CategoryType,
                AssignDate: moment(asset.AssignDate).format("YYYY-MM-DD"),
                AssignmentType: asset.AssignmentType,
                SerialNumber: asset.SerialNumber,
            }));
            const payload = {
                EmployeeId: employeeData?.EmployeeId,
                EmployeeName: employeeData?.FirstName + " " + employeeData?.MiddleName + " " + employeeData?.LastName,
                EmployeeOfficialEmail: employeeData?.OfficialEmail,
                AssetHandoveredTo: formData.handedOverTo,
                AssetHandoveredDate: formData.handedOverDate,
                UpdatedBy: employeeData?.FirstName,
                Comments: formData.comments,
                AssetList: selectedAssets,
                Status: "Active",
                ActiveFlag: "N"
            };
            const response = await axios.post(URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                localStorage.setItem('empId', empId);
                toast.success("Asset handovered successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                navigate("/settlement");
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handlePrevious = () => {
        // navigate("/offboardemployee");
        setFormData({
            AssetHandoveredTo: '',
            AssetHandoveredDate: '',
            comments: ''
        })
    };

    const employeeOptions = employees.map((emp) => ({
        value: emp.OfficialEmail,
        label: `${emp.OfficialEmail}`,
    }));

    const ClearIndicator = () => null;

    const handleSkip = () => {
        localStorage.setItem("Skipped", "Skipped");
        navigate("/settlement")
    };

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Offboard Employee</h3>
                        </div>
                        <div class="col-auto">
                            <a href="#" data-extra-toggle="tab" data-target="#organisation-pan" class="btn btn-primary mt-lg-0 mt-4"><i class="ri-user-star-line"></i> View All Employees</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-1">
                            <div class="circle-tab-wrapper">
                                <ul class="nav nav-tabs circle-tab" role="tablist">
                                    <li class="nav-item step-done">
                                        <a class="nav-link" data-toggle="tab" title="Employee Information" rel="tooltip" role="tab"><i class="ri-user-received-line" onClick={(e) => e.preventDefault()}></i></a>
                                    </li>
                                    <li class="nav-item step-done">
                                        <a class="nav-link active" data-toggle="tab" title="Asset Handover" rel="tooltip" role="tab"><i class="ri-hand-coin-line" onClick={(e) => e.preventDefault()}></i></a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" title="Settlement" rel="tooltip" role="tab"><i class="ri-shake-hands-line" onClick={(e) => e.preventDefault()}></i></a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        <div class="col-lg-11">
                            <div class="tab-pane" id="asset-handover" role="tabpanel">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="card mb-4">
                                            <div class="card-body">
                                                <h5 class="title">Employee Information</h5>
                                                <div class="container-fluid row-rounded">
                                                    <div class="row px-2 py-0">
                                                        <div class="input-group mb-0">
                                                            <input
                                                                type="search"
                                                                class="form-control search-input"
                                                                value={empId}
                                                                disabled
                                                            />
                                                            <div class="input-group-append">
                                                                <button
                                                                    class="btn btn-primary"
                                                                    type="button"
                                                                    title="Search"
                                                                    rel="tooltip"
                                                                >
                                                                    <i class="ri-user-search-line"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {employeeData && (
                                                    <div class="user-info">
                                                        <div class="profile-detail">
                                                            <div class="user-profile-pic">
                                                                <img src={employeeData?.Image ? employeeData?.Image : profileImg} class="img-fluid" />
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-3 mb-4">
                                                            <h6>{employeeData?.FirstName} {employeeData?.MiddleName} {employeeData?.LastName}</h6>
                                                        </div>
                                                    </div>
                                                )}
                                                <div class="row mt-3">
                                                    <div class="form-group col-md-6 col-lg-12 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="oeEmail">Official Email</small>
                                                        <h6>{employeeData?.OfficialEmail}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-12 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="oeEmail">Personal Email</small>
                                                        <h6>{employeeData?.PersonalEmail}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-12  col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="contactNumber">Contact Number</small>
                                                        <h6>{employeeData?.ContactNumber}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="userAccess">User Access</small>
                                                        <h6>{employeeData?.UserAccessLevel}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6 col-sm-6">
                                                        <small class="form-text text-muted mb-2" sm for="employeeType">Employment Type</small>
                                                        <h6>{employeeData?.EmployeeType}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="card mb-4">
                                            <div className="card-body">
                                                <h5 className="title">Asset Handover Information</h5>
                                                <div className="row mt-4">
                                                    <div className="col-md-6">
                                                        <div className="card card-2-highlight">
                                                            <div className="card-body p-2">
                                                                <div className="row">
                                                                    <div className="col-9"><span className="badge badge-info">{assets.length}</span> No of Total Assets</div>
                                                                    <div className="col-3 px-0">
                                                                        <div className="button-cover">
                                                                            <div className="btn-switch button r">
                                                                                <input type="checkbox" className="checkbox" checked={handoverAll} disabled={assets.length === 0} onChange={handleHandoverAllChange} />
                                                                                <div className="knobs"></div>
                                                                                <div className="layer"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12">
                                                                        <small className="form-text text-muted mt-0"><i className="ri-checkbox-multiple-line"></i> Handover All</small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {assets.map((asset, index) => (
                                                            <div className="card card-2" key={asset?.AssetId}>
                                                                <div className="card-body p-2">
                                                                    <div className="row">
                                                                        <div className="col-9">
                                                                            <span className="badge badge-dark">{index + 1}</span> {asset.CategoryType}
                                                                        </div>
                                                                        <div className="col-3 px-0">
                                                                            <div className="button-cover">
                                                                                <div className="btn-switch button r">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="checkbox"
                                                                                        checked={handoverStatus[asset.AssetId]}
                                                                                        onChange={() => handleCheckboxChange(asset.AssetId)}
                                                                                    />
                                                                                    <div className="knobs"></div>
                                                                                    <div className="layer"></div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <small className="form-text text-muted mt-0">
                                                                                <i className="ri-information-2-line"></i> {asset.AssetId} - <i className="ri-information-2-line"></i> {asset.SerialNumber}
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="col-md-12 mb-2">
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label
                                                                    htmlFor="handedOverTo"
                                                                    className="required"
                                                                >
                                                                    Handed Over To
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="handedOverTo"
                                                                    value={
                                                                        employeeOptions.find(
                                                                            (option) => option.value === formData.handedOverTo
                                                                        ) || null
                                                                    }
                                                                    onChange={(selectedOption) =>
                                                                        setFormData({
                                                                            ...formData,
                                                                            handedOverTo: selectedOption ? selectedOption.value : "",
                                                                        })
                                                                    }
                                                                    options={employeeOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    isDisabled={!anyChecked}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="hoDate" className="required">Handed Over Date</label>
                                                                <input type="date" className="form-control" name="handedOverDate" value={formData.handedOverDate} onChange={handleInputChange} disabled={!anyChecked} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group col-md-12">
                                                        <label htmlFor="comments">Comments</label>
                                                        <textarea className="form-control" rows="7" name="comments" value={formData.comments} onChange={handleInputChange} disabled={!anyChecked}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center OFFBsecondTab">
                    <button class="btn btn-light btnPrevious" type="button" onClick={handlePrevious}> Reset</button>
                    <button
                        className="btn btn-light btn-secondary"
                        type="button"
                        onClick={handleSkip}
                    >
                        <i class="ri-close-circle-fill" /> Skip
                    </button>
                    <button class="btn btn-primary btnNext" type="button" onClick={handleNext}>Next <i class="ri-arrow-right-circle-line"></i></button>
                </div>
            </div>
        </div>
    )
}
